module.exports = function (c, d) {
  var f;
  this.sounds = [];
  this.listener = {};
  this.rate = 1;
  this.volumes = [1, 1, 1, 1, 1, 1, 1];
  this.soundCats = {
    nuke_0: 0,
    siren_0: 0,
    jumpS_0: 0,
    beep_0: 0,
    bo_plant: 0,
    bo_diff: 0,
    ambient_1: 2,
    ambient_2: 2,
    ambient_3: 2,
    ambient_4: 2,
    ambient_5: 2,
    ambient_6: 2,
    ambient_7: 2,
    ambient_8: 2,
    aim_0: 3,
    aim_1: 3,
    explosion: 3,
    gclick_0: 3,
    pick_0: 3,
    pick_1: 3,
    reload_1: 3,
    reload_2: 3,
    swsh_0_0: 3,
    swsh_0_1: 3,
    weapon_1: 3,
    weapon_1_0: 3,
    weapon_2: 3,
    weapon_3: 3,
    weapon_4: 3,
    weapon_5: 3,
    weapon_6: 3,
    weapon_7: 3,
    weapon_8: 3,
    weapon_9: 3,
    weapon_10: 3,
    weapon_11: 3,
    weapon_12: 3,
    weapon_13: 3,
    weapon_14: 3,
    weapon_15: 3,
    weapon_16: 3,
    // weapon_17: 3,
    weapon_18: 3,
    whizz_0: 3,
    whizz_1: 3,
    weapon_6_0: 3,
    weapon_1_2: 3,
    weapon_3_0: 3,
    rico_1: 3,
    rico_2: 3,
    case_0: 3,
    case_1: 3,
    weapon_3_2: 3,
    weapon_2_0: 3,
    weapon_1_4: 3,
    weapon_1_3: 3,
    weapon_17: 3,
    weapon_8_0: 3,
    weapon_10_0: 3,
    melee_12: 3,
    swsh_12_0: 3,
    swsh_12_1: 3,
    weapon_4_0: 3,
    melee_equip: 3,
    melee_14: 3,
    swsh_14_0: 3,
    swsh_14_1: 3,
    weapon_1_5: 3,
    weapon_19: 3,
    melee_19: 3,
    swsh_19_0: 3,
    swsh_19_1: 3,
    fart_0: 4,
    headshot_0: 4,
    hit_0: 4,
    impact_0: 4,
    jump_0: 4,
    jump_1: 4,
    land_0: 4,
    punch_0: 4,
    punch_1: 4,
    slide_0: 4,
    spray: 4,
    step_0: 4,
    step_1: 4,
    step_2: 4,
    taunt_0: 4,
    taunt_1: 4,
    taunt_2: 4,
    taunt_3: 4,
    taunt_4: 4,
    cough_1: 4,
    cough_2: 4,
    collect_1: 4,
    bounce_0: 4,
    buy_0: 5,
    buy_1: 5,
    cheer_0: 5,
    reward: 5,
    store: 5,
    tick_0: 5,
  };
  this.setVolume = function (g, h = 0) {
    if (this.volumes[h] != null) {
      this.volumes[h] = g;
      if (h == 0) {
        Howler.volume(g);
      }
      for (var j in this.sounds) {
        if (this.sounds[j].cat == h) {
          this.sounds[j].volume(this.sounds[j].vol * this.volumes[h]);
        }
      }
    }
  };
  this.getSound = function (g, h, j, k) {
    var l =
      g + (h || "") + (window.activeHacker ? "hckd" : "") + (j ? "asset" : "");
    if (!(f = this.sounds[l])) {
      var m =
        (j
          ? c.userAssetsUrl(g + "/sound")
          : ".././sound/" + (window.activeHacker ? "fart_0" : g)) + ".mp3";
      (f = new Howl({
        src: m,
        onload: k,
      })).cat = j ? this.soundCats[6] : this.soundCats[g] || 0;
      this.sounds[l] = f;
    }
  };
  this.onLoad = function (g, h) {
    this.getSound(g, null, null, h);
  };
  this.play = function (g, h, j, k, l) {
    this.getSound(g, null, l);
    if (this.rate && (!j || !f.isPlaying)) {
      f.isPlaying = true;
      var m = f.play();
      f.vol = h || 1;
      f.volume(
        (h || 1) *
          (l
            ? this.volumes[6]
            : this.soundCats[g] == null
              ? 1
              : this.volumes[this.soundCats[g]]),
        m,
      );
      if (j) {
        f.loop(j, m);
      }
      if (k) {
        f.rate((k || 1) * this.rate, m);
      }
    }
  };
  this.stop = function (g) {
    this.getSound(g);
    if (f) {
      f.isPlaying = false;
      f.stop();
    }
  };
  this.endLoops = function () {
    for (var g in this.sounds) {
      if (this.sounds[g] && this.sounds[g]._sounds[0]._loop) {
        this.sounds[g].isPlaying = false;
        this.sounds[g].stop();
      }
    }
  };
  this.stopALL = function () {
    for (var g in this.sounds) {
      if (this.sounds[g]) {
        this.sounds[g].isPlaying = false;
        this.sounds[g].stop();
      }
    }
  };
  this.play3Dv = function (g, j, k, m, q, u, v, w, x) {
    var y = 1 - c.getD3D(j, k, m, w.x, w.y, w.z) / q;
    if (y > 0.1) {
      this.getSound(g, "3dv", x);
      var z = f.play();
      u = (u || 1) * y * d.otherSoundMlt;
      f.vol = u;
      f.volume(
        u *
          (x
            ? this.volumes[6]
            : this.soundCats[g] == null
              ? 1
              : this.volumes[this.soundCats[g]]),
        z,
      );
      f.rate(v || 1, z);
    }
  };
  this.play3D = function (g, h, j, k, m, q, u, v, w) {
    this.getSound(g, "3d", w);
    var x = f.play();
    if ((m = (m || 1) * d.otherSoundMlt) > 0.05) {
      f.vol = m;
      f.volume(
        m *
          (w
            ? this.volumes[6]
            : this.soundCats[g] == null
              ? 1
              : this.volumes[this.soundCats[g]]),
        x,
      );
      f.rate(q || 1, x);
      f.pos(h, j, k, x);
      f.pannerAttr(
        {
          refDistance: u || 25,
          rolloffFactor: v || 1,
        },
        x,
      );
    }
  };
  this.play3DL = function (g, h, j, k, m, q, u, v, w) {
    this.getSound(g, "3d", w);
    var x = f.play();
    if ((m = m || 1) > 0.05) {
      f.volume(
        m *
          (w
            ? this.volumes[6]
            : this.soundCats[g] == null
              ? 1
              : this.volumes[this.soundCats[g]]),
        x,
      );
      f.rate(q || 1, x);
      f.pos(h, j, k, x);
      f.pannerAttr(
        {
          refDistance: u || 25,
          rolloffFactor: v || 1,
          maxDistance: 10000,
          coneOuterGain: 1,
        },
        x,
      );
      f.once("end", () => {
        this.play3DL(g, h, j, k, m, q, u, v, w);
      });
    }
  };
  this.updateSound = function (g, h) {
    if (this.soundCats[g] && this.soundCats[g] == 2) {
      this.stop(g);
    }
    this.sounds[g] = new Howl({
      src: [h],
      format: "mp3",
    });
    this.sounds[g + "3d"] = new Howl({
      src: [h],
      format: "mp3",
    });
    this.sounds[g + "3dv"] = new Howl({
      src: [h],
      format: "mp3",
    });
  };
};
